import type { PerformanceCoreDatapoint, PerformanceDatapoint } from "owa-analytics";
import { getNextPaint } from "owa-analytics-shared";
import MailListItemSelectionSource from "owa-mail-store/lib/store/schema/MailListItemSelectionSource";
import { addPASKeyMetric, pasMetricsEnabled } from "owa-performance";
import { getSmiCustomDataRawArguments } from "./selectMailItemDatapointGetterAndSetter";

// Mail list clicks reported to PAS (aka.ms/pas): 1st = empty reading pane, 2nd = switching
let pasSelectMailItemClickCount = 0;

export function addSelectMailItemPASMetric(dp: PerformanceCoreDatapoint | PerformanceDatapoint): void {
    if (pasSelectMailItemClickCount >= 2 ||
        !pasMetricsEnabled() ||
        dp.getEventName() !== "SelectMailItem" ||
        getSmiCustomDataRawArguments()?.mailListItemSelectionSource !==
            MailListItemSelectionSource.MailListItemBody) {
        return;
    }
    
    const pasMetricName = ++pasSelectMailItemClickCount === 1 ? "smi1" : "smi2";
    // Runs after the paint that ends the datapoint, so E2ETimeElapsed is final.
    getNextPaint(() => {
        const duration = dp.getE2ETimeElapsed();
        if (duration !== undefined) {
            addPASKeyMetric(pasMetricName, duration);
        }
    });
}
